export { BrandHeader } from './BrandHeader';
export type { BrandHeaderProps } from './BrandHeader.types';
